import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillLineItem } from "@common/types/bill";
import { billLineContribution } from "@common/helpers/lineItems";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { Amount } from "@design-system/Amount/Amount";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { BillLineItemsViewCallbacks } from "../types";

export const AmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, BillLineItem, number>) => {
        const lineItem = row.original;
        const { callbacks } = useViewTableMeta<
            BillLineItemsViewCallbacks,
            unknown
        >(table);

        return (
            <ViewTableCell captureClicks>
                <EditableCellContent
                    onClick={() => callbacks?.onBillClick?.(lineItem)}
                    readonly
                >
                    <Amount amount={billLineContribution(lineItem)} />
                </EditableCellContent>
            </ViewTableCell>
        );
    },
);
